import React from "react";

import dsdesExploreApi from "apis/dsdesExplore";
import { Typography, Button } from "clearsense-ui/components";
import { Unlink } from "clearsense-ui/icons";

import DsdeReferenceOverview from "./DsdeReferenceOverview";
import ReferenceValuesContainer from "./ReferenceValuesContainer";

const AssociatedReferenceSources = ({
  dsde,
  fetchAssociatedReferenceSource,
  associatedReferenceSource,
}) => {
  const dissociateReferenceSource = async () => {
    try {
      await dsdesExploreApi.dissociateReferenceSource(
        dsde.id,
        associatedReferenceSource
      );
      fetchAssociatedReferenceSource();
    } catch (error) {
      logger.log(error);
    }
  };
  return (
    <>
      <div className="flex p-2 bg-gray-50 dark:bg-gray-800">
        <div className="pl-6 w-full ">
          <Typography type="semibold" style="h4">
            Associated Reference Source:
            <span className="ml-2 font text-indigo-600">
              {associatedReferenceSource.name}
            </span>
          </Typography>
          <Typography type="regular" className="text-gray-500">
            Description and the scope of the data source is mentioned here
          </Typography>
        </div>
        <div>
          <Button
            label="Unlink"
            style="text"
            className="text-indigo-600 dark:hover:text-indigo-300"
            icon={Unlink}
            onClick={dissociateReferenceSource}
          />
        </div>
      </div>
      <div className="mt-4 flex space-x-5">
        <ReferenceValuesContainer
          associatedReferenceSource={associatedReferenceSource}
        />
        <DsdeReferenceOverview
          associatedReferenceSource={associatedReferenceSource}
        />
      </div>
    </>
  );
};

export default AssociatedReferenceSources;
